import React, { useCallback } from "react";
import cn from "classnames";
import { useFormField } from "state/hooks/useFormField";
import { useFormContext } from "playground/cms/Form";
import Checkbox from "components/fields/checkbox/Checkbox";
import Popover from "components/Popover";
import IconButton from "components/IconButton";
import SelectList, { SelectListItem } from "playground/ui/SelectList";
import { describeCron } from "./cronUtils";

export function CronItem({ onEdit, onDelete }) {
    const { value: active, onChange: setActive } = useFormField("active");
    const { value: cronSchedule } = useFormField("cron_schedule");
    const { onSave } = useFormContext();

    const handleToggleActive = useCallback(() => {
        setActive(!active);
        onSave();
    }, [active, setActive, onSave]);

    return (
        <div
            className={cn("cron-item cols cols-middle gap-sm", {
                "is-disabled": !active,
            })}
        >
            <Checkbox value={active} onChange={handleToggleActive} />
            <div className={"grow"}>
                <div className={"cron-description"}>
                    {describeCron(cronSchedule)}
                </div>
                <code className={"cron-expression-raw"}>
                    {cronSchedule}
                </code>
            </div>
            <Popover
                trigger={({ onClick }) => (
                    <IconButton icon={"mui-more_vert"} onClick={onClick} />
                )}
                content={({ onClose }) => (
                    <SelectList>
                        <SelectListItem
                            label={"Edytuj"}
                            onClick={() => {
                                onEdit();
                                onClose();
                            }}
                        />
                        <SelectListItem
                            label={"Usun"}
                            onClick={() => {
                                onDelete();
                                onClose();
                            }}
                        />
                    </SelectList>
                )}
            />
        </div>
    );
}

CronItem.defaultProps = {};

export default CronItem;